(function ($, window) {
    // build content for zielgruppenblog
    var $isZGB = $('#isZGB');

    if ($isZGB.length) {
        $("div.slider-wrapper").addClass("border-bottom");

        var daycontent = [];
        var daylist = [];

        $('.day').each(function () {
            var istitle = $(this).find('.daytitle .d-title').html();
            if (istitle) {
                var temp_day_content = [];
                var temp_day_list = [];
                $(this).find('.daysection').each(function () {
                    var title = $(this).find('.d-title').html();
                    var text = $(this).find('.d-text').html();
                    temp_day_content.push([title, text])
                });
                daycontent.push(temp_day_content);
                $(this).find('.daytitle').each(function () {
                    daylist.push($(this).find('.d-title').html());
                });
            }
        });

        if (daycontent.length > 0 && daylist.length > 0) {
            setDaysParts(daycontent, daylist);
        }

        /*
        // change Slider Header to ZGB Header
        var zgbHeader = $('#zgb-headline').html();

        if (zgbHeader != "") {
            if ($('.dce-header .headline.capital').length) {
                $('.dce-header .headline.capital').each(function () {
                    $(this).html(zgbHeader);
                });
            }
            else {
                $('.dce-header .slick-slide .teaser-box').prepend("<div class='headline capital'>" + zgbHeader + "</div>");
            }
        }
        */

        var stickyPosition = $(".header-wrapper .header").height();

        // scroll effect on Large Screens
        if (Foundation.MediaQuery.current == "large") {
            var stickyPositionNew = $('.header-wrapper .header .main-nav').height() + 12;
            stickyPosition = stickyPositionNew;
        }
        // scroll effect on Large Screens - END

        var emSize = parseFloat($("body").css("font-size"));
        var emPosition = (stickyPosition / emSize) - 0.5;

        var container = $("#blogHeader").closest(".tx-dce-pi1");

        if (container.length == 0) {
            $("#blogHeader .day-section .row").attr("data-margin-top", emPosition);//.foundation();
            $("#blogHeader .day-section .row").attr("data-sticky", "true").foundation();
        }
        else {
            var id = container.attr("id");
            if (!id)
                id = "blog-days-container";
            container.attr("id", id);
            $("#blogHeader .day-section .row").attr("data-margin-top", emPosition);
            $("#blogHeader .day-section .row").attr("data-top-anchor", id + ":top");
            $("#blogHeader .day-section .row").attr("data-btm-anchor", id + ":bottom");//.foundation();
            $("#blogHeader .day-section .row").attr("data-sticky", "true").foundation();

            $("#blogHeader .day-section .row").on('sticky.zf.stuckto:top', function () {
                $("#blogHeader .day-section .row").show();
            });
            $("#blogHeader .day-section .row").on('sticky.zf.unstuckfrom:bottom', function () {
                $("#blogHeader .day-section .row").hide();
            });
        }
    }
})(jQuery, window);

function setDaysParts(daycontent, daylist){
    $("#days-wrap").empty();
    $("#days-wrap").append('<div id="days-act" class="selection"></div><div id="days-list"></div>');

    $("#day-parts-wrap").empty();
    $("#day-parts-wrap").append('<div id="day-parts-act" class="selection"></div><div id="day-parts-list"></div>');

    for (var i = 0; i < daylist.length; i++) {
        if(daylist[i]) {
            $("#days-list").append('<button class="list-buttons days-list days-list-' + i + '" data-day="' + i + '" title="' + daylist[i] + '">' + daylist[i] + '</button>');
        }
    }

    setday(0, daycontent[0], daylist[0], daylist);
    setNavigation(daycontent, 0, 0, daylist, 0);

    //$('#days-wrap button').click(function () {
    $('#days-wrap').on('click', 'button', function () {
        var day = $(this);
        setNavigation(daycontent, parseInt(day.attr('data-day')), 0, daylist, "-");
        reinitExternalMap();
        reinitSocialMedia();
    });

    $('#day-parts-wrap').on('click', 'button', function () {
        var part = $(this);
        setNavigation(daycontent, parseInt(part.attr('data-day')),  parseInt(part.attr('data-part')), daylist, parseInt(part.attr('data-day')));
        reinitExternalMap();
        reinitSocialMedia();
    });

    $('button.day-section-navigation').click(function () {
        var $this = $(this);
        var dayToGo = parseInt($this.attr('data-day'));
        var dayPartToGo = parseInt($this.attr('data-part'));
        var actualDay = parseInt($("#days-list button.active").attr('data-day'));

        setNavigation(daycontent, dayToGo, dayPartToGo, daylist, actualDay);
        reinitExternalMap();
        reinitSocialMedia();

        var $scrollTo = $('.content-section');
        var headerTop = $('.header').css('top') || 0;
        headerTop = parseInt(headerTop);
        var addValue = - (( $('.header').height() + headerTop) + $('.zielgruppenblog-post .blog-header .day-section .sticky.is-stuck').height() + 50);

        if($(window).width() < 640){
            addValue = addValue + 25;
        }

        $("html,body").animate({scrollTop: $scrollTo.offset().top + addValue, scrollLeft: 0},300, function(){
            if (Foundation.MediaQuery.current == "large") {
                setTimeout(function () {
                    var headerHeight = $(".header-wrapper > .header > .row").height();
                    var headerPositionNew = headerHeight + 18;

                    $(".header-wrapper .header").removeAttr('style');
                    $(".header-wrapper .header").css("top", "-" + headerPositionNew + "px");
                },150);
            }
        });
    });
}

function setNavigation(daycontent, dayToGo, dayPartToGo, daylist, actualDay){
    var nextDayNr = ""; var nextDayPartNr = "";
    var prevDayNr = ""; var prevDayPartNr = "";


    // check for next day/part
    if(daycontent[dayToGo][dayPartToGo + 1] !== undefined){
        nextDayNr = dayToGo;
        nextDayPartNr = dayPartToGo + 1;
    }
    else{
        if(daycontent[dayToGo + 1] !== undefined){
            nextDayNr = dayToGo + 1;
        }
        else{
            nextDayNr = 0;
        }

        nextDayPartNr = 0;
    }

    $("#day-section-next button").attr('data-day', nextDayNr);
    $("#day-section-next button").attr('data-part', nextDayPartNr);

    // END - next

    // check for prev day/part
    if(daycontent[dayToGo][dayPartToGo - 1] !== undefined){
        prevDayNr = dayToGo;
        prevDayPartNr = dayPartToGo - 1;
    }
    else{
        var prevDay = [];

        if(daycontent[dayToGo - 1] !== undefined){
            prevDayNr = dayToGo - 1;
            prevDay = daycontent[prevDayNr];
        }
        else{
            prevDayNr = daycontent.length - 1;
            prevDay = daycontent[prevDayNr];
        }

        prevDayPartNr = prevDay.length - 1;
    }

    $("#day-section-prev button").attr('data-day', prevDayNr);
    $("#day-section-prev button").attr('data-part', prevDayPartNr);
    // END - prev


    if(actualDay == dayToGo){
        setpart(dayToGo, dayPartToGo, daycontent[dayToGo]);
    }
    else{
        setday(dayToGo, daycontent[dayToGo], daylist[dayToGo], daylist);
        setpart(dayToGo, dayPartToGo, daycontent[dayToGo]);
    }
}


function setday(day, dayarr, dayname, daylist) {
    $("#days-act").empty();
    $("#day-parts-list").empty();
    $("#days-sections-content").empty();

    for (var i = 0; i < dayarr.length; i++) {
        $("#day-parts-list").append('<button class="list-buttons days-section days-section-' + i + '" data-part="' + i + '" data-day="' + day + '" title="' + dayarr[i][0] + '">' + dayarr[i][0] + '</button>');
    }

    $("#days-act").append(dayname);
    $("#days-sections-content").append($(dayarr[0][1]).hide().fadeIn(800));

    $("#day-parts-act").empty();
    $("#day-parts-act").append(dayarr[0][0]);

    for (var i = 0; i < daylist.length; i++) {
        $("button.days-list[data-day=" + i + "]").removeClass("active");
    }
    $("button.days-list[data-day=" + day + "]").addClass("active");
    $("button.days-section[data-part='0']").addClass("active");

    addContentJsFunctions();
}

function setpart(day, part, dayarr) {
    $("#day-parts-act").empty();
    $("#day-parts-act").append(dayarr[part][0]);

    $("#days-sections-content").empty();
    $("#days-sections-content").append($(dayarr[part][1]).hide().fadeIn(800));

    for (var i = 0; i < dayarr.length; i++) {
        $("button.days-section[data-part=" + i + "]").removeClass("active");
    }

    $("button.days-section[data-part=" + part + "]").addClass("active");

    addContentJsFunctions();
}

function addContentJsFunctions(){
    var transitionEndEvents = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";
    var treshold = 70;

    $("#days-sections-content .more-wrapper").each(function() {
        addReadMoreButtons($(this), transitionEndEvents, treshold);
    });

    // reinit Sliders
    setTimeout(function(){
        // reinit Image Errors
        window.pixelpoint.images.initializeErrors($("#days-sections-content"));
        window.ppComponents.sliders.main.init($("#days-sections-content").find(".main-slider"));
    },200);
}



function reinitExternalMap(){
    setTimeout(function() {
        if($(".external-map-wrapper").length > 0){
            $(".external-map-wrapper").each(function(index,element){
                if($(element).is(":visible")){
                    window.externalMap.init($(element), true);
                }
            });

            setTimeout(function(){
                $(window).trigger('load.zf.sticky');
            },500);
        }
    },500);
}

function reinitSocialMedia(){
    setTimeout(function() {
        if(!!window.instgrm && !!window.instgrm.Embeds && !!window.instgrm.Embeds.process){
            window.instgrm.Embeds.process();
        }        
    },500);
}